import { createReducer } from '@reduxjs/toolkit';
import type { Translations } from '../../../../ssr/src/Schema/Translation';

export const translationReducer = createReducer<Translations>({}, () => {});
